<template lang="pug">
  #app
    #nav(:class="classNav")
      .nav-container
        .logo
          router-link(to="/")
            img(src="./assets/industrias_de_nutraceuticos-logo.svg")
        .hamburguer-container
          button.hamburger.hamburger--collapse(type="button", @click="openMenu", :class="menuClass")
            span.hamburger-box
            span.hamburger-inner
        .menu(:class="menuClass")
          ul
            li(@click="transparentHeader")
              router-link(to="/") Inicio
            li(@click="whiteHeader")
              router-link(to="/nosotros") Acerca de
            li(@click="whiteHeader")
              router-link(to="/productos") Productos
            li(@click="whiteHeader")
              router-link(to="/contacto") Contacto
        .social-media
          ul
            li
              a(href="https://www.facebook.com/industriasdenutraceuticos/" target="_blank")
                i(class="fab fa-facebook-f")
            li
              a(href="https://www.instagram.com/industriasden/" target="_blank")
                i(class="fab fa-instagram")
    router-view
    footer
      .container
        .flex-row.left
          .col
            img(src="./assets/home/industrias_de_nutraceuticos.png")
            h3 Especialistas en nutracéuticos
            p En Industrias de nutracéuticos ofrecemos suplementos alimenticios de calidad premium que buscan beneficiar la salud de México y el mundo.
          .col
            h5.title.blue Navegación
            ul
              li(@click="transparentHeader")
                router-link(to="/") Inicio
              li(@click="whiteHeader")
                router-link(to="/nosotros") Acerca de
              li(@click="whiteHeader")
                router-link(to="/productos") Productos
              li(@click="whiteHeader")
                router-link(to="/contacto") Contacto
          .col
            h5.title.blue Contacto
            ul
              li(@click="transparentHeader")
                router-link(to="/") industriasdenutraceuticos.com
              li
                a(href="mailto:info@industriasdenutraceuticos.com") info@industriasdenutraceuticos.com
              li
                a(href="tel:3321524248") T. (33) 2152-4248 / 49
</template>
<style lang="scss" scoped>
  @import "styles/global.scss";
</style>
<script>
  export default {
    data: function() {
      return{
        classNav: 'white',
        activeMenu: false,
        menuClass: ''
      };
    },
    methods : {
      transparentHeader() {
       
        this.classNav='transparent';
        this.activeMenu = !this.activeMenu;
        if(this.activeMenu){
          this.menuClass = 'is-active'
        }
        else {
          this.menuClass = '';
        }
      },
      whiteHeader() {
        this.classNav='white';
        this.activeMenu = !this.activeMenu;
        if(this.activeMenu){
          this.menuClass = 'is-active'
        }
        else {
          this.menuClass = '';
        }
      },
      openMenu() {
        this.activeMenu = !this.activeMenu;
        if(this.activeMenu){
          this.menuClass = 'is-active'
        }
        else {
          this.menuClass = '';
        }
        
      }
    }
  }
</script>
